import { render, staticRenderFns } from "./CardPropertyBrigade.vue?vue&type=template&id=6e291779&scoped=true&"
import script from "./CardPropertyBrigade.vue?vue&type=script&lang=js&"
export * from "./CardPropertyBrigade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e291779",
  null
  
)

export default component.exports